import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import { uniqBy } from 'lodash';
import SimpleInput from 'components/SimpleInput';
import RadioButtons from 'components/RadioButtons';
import StyledSelect from 'components/StyledSelect';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

class LocationInfo extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    const { installerType = '', subfloorType = '', helpers = 'N/A', crewId = '',
            phase: { appointments = [] } } = this.props;
    this.state = {
      installerType,
      subfloorType,
      helpers,
      eligibleCrews: uniqBy(appointments
        .filter(({ assignee_type }) => assignee_type === 'Crew')
        .map(({ assignee_id, assignee }) => ({ label: assignee, value: assignee_id })), 'value'),
      crewId,
      errors: {},
    };
  }

  static VALIDATIONS = {
    crewId: true,
    installerType: true,
    subfloorType: true,
    helpers: true,
  }

  handleSubmit = () => {
    if (!this.validate()) return;
    const { installerType, subfloorType, helpers, crewId } = this.state;
    this.props.updateFormData({ installerType, subfloorType, helpers, crewId, tab: 2 });
  }

  handleCrewId = value => this.setState({ crewId: value.toString() });

  handleInstallerType = value => this.setState({ installerType: value });

  handleSubfloorType = value => this.setState({ subfloorType: value });

  handleHelpers = e => this.setState({ helpers: e.target.value });

  render = () => {
    const { crewId, installerType, subfloorType, helpers, eligibleCrews, errors } = this.state;
    const installerTypeButtons = [
      { label: 'New Crew', value: 'New Crew' },
      { label: 'Existing Crew', value: 'Existing Crew' },
    ];
    const subfloorOptions = [
      { value: 'Wood', label: 'Wood' },
      { value: 'Concrete', label: 'Concrete' },
      { value: 'Combination', label: 'Combination' },
      { value: 'Other', label: 'Other' },
    ];
    return (<div>
      <h6 className={S.signatureTitle}>Location Info</h6>
      <StyledSelect
        className={S.select}
        label="Crew Name"
        onChange={this.handleCrewId}
        options={eligibleCrews}
        value={crewId}
        placeholder={'Select Crew'}
        error={errors.crewId}
        required
      />
      <RadioButtons
        label="Crew Type*"
        onChange={this.handleInstallerType}
        selectedValue={installerType}
        radioButtons={installerTypeButtons}
        text="Is this a new or existing crew?"
        required
      />
      <StyledSelect
        className={S.select}
        label="Subfloor Type"
        onChange={this.handleSubfloorType}
        options={subfloorOptions}
        value={subfloorType}
        placeholder={'Select'}
        error={errors.subfloorType}
        required
      />
      <SimpleInput
        label="Helper(s)*"
        text={helpers}
        errors={errors.helpers}
        onChange={this.handleHelpers}
        required
      />
      <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
    </div>);
  }
}

LocationInfo.propTypes = {
  phase: PhaseType.isRequired,
  crewId: PropTypes.string,
  installerType: PropTypes.string,
  subfloorType: PropTypes.string,
  helpers: PropTypes.string,
  errors: PropTypes.shape({
    installerType: PropTypes.arrayOf(PropTypes.string),
    subfloorType: PropTypes.arrayOf(PropTypes.string),
    helpers: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(LocationInfo);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/locationInfo.jsx